<template>
  <div class="py-4 bg-light_gray border-t border-b border-section_border">
    <div class="px-4">
      <template v-if="token">
        <a @click="confirmSave" class="button-primary block">
          {{ $t('tour_save_label') }}
        </a>
      </template>
      <template v-else>
        <p>{{$t('tour_login_message')}}</p>
      </template>
    </div>
    <div class="mt-4 px-4">
      <a class="button-secondary block button-icon icon-left" @click="back">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_back_to_plan_top_label') }}</span>
      </a>
    </div>
    <div class="mt-4 px-4">
      <a :href="maas_top_url()" class="button-secondary block button-icon icon-left">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_maas_top_link') }}</span>
      </a>
    </div>
    <plan-save-modal
      v-show="modalShow"
      :defaultTitle="title"
      :closeModal="() => closeModal()"
      :callback="() => save()"
      @updateTitle="title => updateTitle(title)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PlanSaveModal from '../molecules/PlanSaveModal'
import Constants from '../../constants'

export default {
  components: {
    PlanSaveModal
  },
  props: {
    planId: {
      type: String,
      default: function () {
        return undefined
      }
    }
  },
  data () {
    return {
      modalShow: false,
      showMapPanel: false
    }
  },
  methods: {
    alertModal: function () {
      if (this.showMapPanel) {
        this.$alert({ message: 'プラン作成画面に戻る場合は「旅行プラン作成に戻る」より行ってください。' })
      } else {
        this.$alert({ message: '保存せずに、プラン選択画面に戻る場合はページ下部の「プラン選択に戻る」より行ってください。' })
      }
      history.pushState(null, null, null)
    },
    confirmSave: function () {
      this.modalShow = true
    },
    save: function () {
      // GoogleAnalytics
      this.$gtag.event("プラン保存", {
        plan_id: this.planId
      });
      window.removeEventListener('popstate', this.alertModal)
      this.modalShow = false
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('plans/save', this.planId)
        .then((id) => {
          this.$store.dispatch('loading/endLoading')
          const areaId = this.$store.getters['user/getAreaId']
          if (areaId == Constants.DEFAULT_AREA_ID){
            this.$router.push({ name: 'complete', params: { lang: this.$store.getters['user/getLang'], planId: id } })
          }else{
            this.$router.push({ name: 'complete', params: { lang: this.$store.getters['user/getLang'], planId: id, areaId: areaId } })
          }
        })
        .catch(() => {
          this.$store.dispatch('loading/resetLoading')
          this.$alert({ message: this.$t('tour_system_error_message') })
        })
    },
    back: function () {
      window.removeEventListener('popstate', this.alertModal)
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID){
        this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'] }})
      }else{
        this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'], areaId: areaId }})
      }
    },
    closeModal: function () {
      this.modalShow = false
    },
    updateTitle: function (title) {
      this.$store.dispatch('plans/updateTitle', title)
    },
    maas_top_url: function () {
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID) {
        return Constants.LINK_BASE_URL + '/'
      } else {
        return Constants.LINK_BASE_URL + '/' + areaId
      }
    },
    updateShowMapPanel: function (showMapPanel) {
      this.showMapPanel = showMapPanel
    },
    setBackAlert: function () {
      history.pushState(null, null, null)
      window.addEventListener('popstate', this.alertModal)
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken'
    }),
    title: function () {
      return this.$store.getters['plans/getTitle']
    }
  }
}
</script>
